export enum StepIds {
  Car = 'car',
  CarConfirmation = 'carConfirmation',
  Device = 'device',
  Inspection = 'inspection',
  OwnerConfirmation = 'ownerConfirmation',
  OwnerTypeConfirmation = 'ownerTypeConfirmation',
  Payer = 'payer',
  PaymentMethod = 'paymentMethod',
  Policy = 'policy',
  Residence = 'residence'
}
